'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
    displayName: 'Day',


    propTypes: {
        handleClick: _react2.default.PropTypes.func.isRequired,
        date: _react2.default.PropTypes.object.isRequired,
        //month: React.PropTypes.object.isRequired,
        today: _react2.default.PropTypes.object.isRequired,
        selected: _react2.default.PropTypes.object,
        children: _react2.default.PropTypes.node
    },

    render: function render() {
        var _this = this;

        var classes = ['Day'];
        if (this.props.today.isSame(this.props.date, 'day')) {
            classes.push('today');
        }
        if (this.props.selected && this.props.selected.isSame(this.props.date, 'day')) {
            classes.push('selected');
        }
        classes = classes.concat(this.props.classes);

        var body = void 0;
        if (!!this.props.children) {
            body = this.props.children;
        } else {
            body = _react2.default.createElement(
                'button',
                {
                    className: 'Day-inner',
                    onClick: function onClick() {
                        return _this.props.handleClick(_this.props.date);
                    },
                    type: 'button'
                },
                this.props.date.format('D')
            );
        }

        return _react2.default.createElement(
            'td',
            { className: classes.join(' '),
                'data-date': this.props.date.toISOString(),
                'data-day': this.props.date.format('D')
            },
            body
        );
    }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-calendar-pane/lib/Day.js
// module id = 1033
// module chunks = 0